exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-card[data-v-8330c60c]{width:1000px;height:850px}.modal-card-body[data-v-8330c60c]{scrollbar-width:thin}", ""]);

// exports
